import { useMemo, useState } from 'react'
import { he } from '../../locales/he'
import { IAllShows, IVodShow } from '../../types'
import {
  Container,
  FiltersContainer,
  FiltersScrollArea,
  PosterLink,
  Show,
  ShowsGrid,
  Title,
} from './AllShows.styles'
import { mediaCdnReplace } from '../../utils'

type Props = {
  item: IAllShows
}
const alphabeticalShows = (shows: IVodShow[]) =>
  shows.sort((a, b) => (a.title < b.title ? -1 : 1))

export const AllShows = ({ item: allShows }: Props) => {
  const {
    hide_ab_filter,
    showsGroups: showGs,
    shows: unfilteredShows,
  } = allShows

  const [shows, setShows] = useState({
    shows: alphabeticalShows(unfilteredShows),
    filterIndex: 0,
  })

  const showsGroups = Object.values(showGs).filter(
    showGroup => showGroup.entry.length > 0
  )

  return (
    <Container>
      {!hide_ab_filter && (
        <FiltersContainer>
          <FiltersScrollArea filterIndex={shows.filterIndex}>
            <span
              onClick={() =>
                setShows({
                  shows: alphabeticalShows(unfilteredShows),
                  filterIndex: 0,
                })
              }
            >
              {he.all}
            </span>
            {showsGroups.map(({ alphabetSymbol, entry }, index) => (
              <span
                key={index}
                onClick={() =>
                  setShows({ shows: entry, filterIndex: index + 1 })
                }
              >
                {alphabetSymbol}
              </span>
            ))}
          </FiltersScrollArea>
        </FiltersContainer>
      )}

      <ShowsGrid>
        {shows.shows
          ?.filter(({ url }) => !!url)
          .map(show => {
            const { poster, title, url, id } = show
            return (
              <Show key={`show ${id}`}>
                <PosterLink href={url}>
                  <Poster poster={mediaCdnReplace(poster)} alt={title} />
                </PosterLink>
                <Title>{title}</Title>
              </Show>
            )
          })}
      </ShowsGrid>
    </Container>
  )
}

const Poster = ({ poster, alt }: { poster: string; alt: string }) => {
  const src = useMemo(
    () =>
      mediaCdnReplace(
        (poster ?? '/assets/images/matrix-placeholder.png').replace(
          /png|jpg|jpeg/g,
          'webp'
        )
      ),
    [poster]
  )
  return <img loading='lazy' src={src} alt={alt.toString()} />
}

export default AllShows
